/**
 * Locks background scroll while header search overlay is open.
 * Watches [data-search-container] for Booster focus/active classes.
 */
(function () {
  'use strict';

  var OPEN_CLASSES = ['focused', 'active', 'show', 'visible'];
  var BODY_CLASS = 'search-is-open';
  var scrollY = 0;
  var locked = false;

  function isSearchContainerOpen(el) {
    return OPEN_CLASSES.some(function (name) {
      return el.classList.contains(name);
    });
  }

  function isAnySearchOpen() {
    var containers = document.querySelectorAll('[data-search-container]');
    for (var i = 0; i < containers.length; i++) {
      if (isSearchContainerOpen(containers[i])) return true;
    }
    return false;
  }

  function isOtherScrollLockActive() {
    return (
      document.body.classList.contains('menu-active') ||
      document.body.classList.contains('megamenu-open') ||
      document.body.classList.contains('modal-open')
    );
  }

  function lockScroll() {
    if (locked) return;
    locked = true;
    scrollY = window.scrollY;
    document.documentElement.classList.add(BODY_CLASS);
    document.body.classList.add(BODY_CLASS);
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    if (!locked) return;
    if (isAnySearchOpen() || isOtherScrollLockActive()) return;

    locked = false;
    document.documentElement.classList.remove(BODY_CLASS);
    document.body.classList.remove(BODY_CLASS);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }

  function syncScrollLock() {
    if (isAnySearchOpen()) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }

  function observeSearchContainers() {
    document.querySelectorAll('[data-search-container]').forEach(function (el) {
      if (el.__searchScrollLockObserved) return;
      el.__searchScrollLockObserved = true;

      new MutationObserver(syncScrollLock).observe(el, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
    syncScrollLock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSearchContainers);
  } else {
    observeSearchContainers();
  }

  document.addEventListener('shopify:section:load', observeSearchContainers);
})();
